import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from '../core/GlobalStyle';

function makeTheme(colors) {
  var monospace = "'Roboto Mono', monospace";
  var copy = "'Merriweather', serif";
  var icomoon = "IcoMoon";
  var icomoonCustom = "IcoMoonCustom";
  var breakpoints = ['575px', '720px', '65rem', '75rem'];
  var fontSizes = {
    h1: "3rem",
    h2: "2.2rem",
    h3: "1.5rem",
    h4: "1rem",
    h5: "1rem",
    p: "1rem",
    s: ".9rem",
    xs: ".8rem"
  };
  var widths = {
    nav: '15rem',
    textWrapper: '650px'
  };
  return {
    breakpoints: breakpoints,
    colors: colors,
    widths: widths,
    fonts: {
      heading: monospace,
      copy: copy,
      monospace: monospace,
      icomoon: icomoon,
      icomoonCustom: icomoonCustom
    },
    fontSizes: fontSizes,
    textStyles: {
      h1: {
        color: colors.heading,
        fontFamily: monospace,
        fontSize: fontSizes.h1,
        fontWeight: "700",
        letterSpacing: "-.02em",
        overflowWrap: "break-word",
        lineHeight: '1.2em'
      },
      h2: {
        color: colors.heading,
        fontFamily: monospace,
        fontSize: fontSizes.h2,
        fontWeight: "700",
        letterSpacing: "-.02em",
        overflowWrap: "break-word",
        lineHeight: '1.2em'
      },
      h3: {
        color: colors.heading,
        fontFamily: monospace,
        fontSize: fontSizes.h3,
        fontWeight: "700",
        letterSpacing: "-.02em",
        overflowWrap: "break-word",
        lineHeight: '1.2em'
      },
      h4: {
        color: colors.heading,
        fontFamily: monospace,
        fontSize: fontSizes.h4,
        fontWeight: "700",
        overflowWrap: "break-word",
        lineHeight: '1.2em'
      },
      h5: {
        color: colors.heading,
        fontFamily: monospace,
        fontSize: fontSizes.h5,
        overflowWrap: "break-word",
        lineHeight: '1.2em'
      },
      p: {
        lineHeight: '1.8em'
      },
      small: {
        fontSize: fontSizes.s,
        lineHeight: '1.2em'
      },
      disclaimer: {
        fontSize: fontSizes.xs,
        lineHeight: '1em',
        fontStyle: 'italic',
        color: colors.copyLighter
      },
      s1: {
        fontFamily: monospace,
        fontStyle: 'italic',
        color: colors.copyLight
      },
      s2: {
        fontFamily: monospace,
        fontStyle: 'italic',
        color: colors.copyLighter
      },
      strong: {
        fontWeight: "700"
      },
      weak: {
        color: colors.copyLight
      },
      em: {
        fontStyle: "italic"
      },
      monospace: {
        fontFamily: monospace
      },
      label: {
        fontFamily: monospace,
        fontSize: fontSizes.xs,
        lineHeight: '1em'
      },
      copy: {
        fontFamily: copy
      },
      code: {
        fontFamily: monospace,
        fontSize: fontSizes.xs,
        backgroundColor: colors.bgAlt,
        padding: '.25rem',
        borderRadius: '3px'
      },
      codeLabel: {
        fontFamily: monospace,
        fontSize: fontSizes.s,
        lineHeight: '1em'
      },
      icon: {
        fontFamily: icomoon
      }
    }
  };
}

export var LightTheme = function LightTheme() {
  var extendColors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return makeTheme(_objectSpread({
    bg: '#ffffff',
    bgAlt: '#edf7fb',
    copy: '#233544',
    copyLight: '#9faaaf',
    copyLighter: '#c1cbd0',
    bgInvert: '#0e151b',
    copyInvert: '#ffffff',
    line: '#EEEEEE',
    outline: '#DDDDDD',
    placeholder: '#CCCCCC',
    link: '#527fd7',
    touch: '#a0a0a0',
    touchHover: '#b4b4b4',
    focus: '#527fd7',
    bgInput: '#ffffff',
    primary: '#527fd7',
    primaryMuted: '#9db7e9',
    secondary: '#e17564',
    tertiary: '#f1dd8b',
    positive: '#38C169',
    negative: '#e85656',
    warning: '#F5A623',
    weightMilli: '#7b8d9c',
    weightMicro: '#c5ccdb',
    terminalPrimary: '#319dcd',
    terminalSecondary: '#ce4133',
    terminalTertiary: '#fee380',
    terminalComment: '#9480a2',
    buttonBg: '#f4f4f4',
    buttonBgHover: '#ffffff',
    buttonTextFocus: '#527fd7',
    buttonBgInvert: '#0e151b',
    buttonBgHoverInvert: '#333333',
    buttonTextFocusInvert: '#527fd7'
  }, extendColors));
};
export var DarkTheme = function DarkTheme() {
  var extendColors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return makeTheme(_objectSpread({
    bg: '#0e151b',
    bgAlt: '#0e151b',
    copy: '#ffffff',
    bgInvert: '#ffffff',
    copyInvert: '#233544',
    line: '#EEEEEE',
    outline: '#DDDDDD',
    link: '#527fd7',
    bgInput: '#0e151b',
    primary: '#527fd7',
    primaryMuted: '#9db7e9',
    secondary: '#e17564',
    tertiary: '#f1dd8b',
    positive: '#38C169',
    negative: '#e85656',
    warning: '#F5A623',
    weightMilli: '#7b8d9c',
    weightMicro: '#c5ccdb',
    terminalPrimary: '#319dcd',
    terminalSecondary: '#ce4133',
    terminalTertiary: '#fee380',
    terminalComment: '#9480a2',
    buttonBg: '#f4f4f4',
    buttonBgHover: '#f9f9f9'
  }, extendColors));
};
export var Theme = function Theme(props) {
  return React.createElement(ThemeProvider, {
    theme: props.theme || LightTheme()
  }, React.createElement(React.Fragment, null, React.createElement(GlobalStyle, null), props.children));
};
export var Head = function Head() {
  return React.createElement("link", {
    href: "https://fonts.googleapis.com/css?family=Roboto+Mono|Merriweather",
    rel: "stylesheet"
  });
};